import store from '@/store';
import i18n from '@/plugins/i18n';

export default function auth({ next, router }) {
  store.dispatch('auth/me').then(
    () => next(),
    () => router.replace({ name: 'login', params: { locale: i18n.locale } }),
  );
}
